import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/shared/PageHeader';
import { HotWalletCard } from '@/components/features/wallets/HotWalletCard';
import { WalletTransactionHistory } from '@/components/features/wallets/WalletTransactionHistory';
import { ReplaceHotWalletDialog } from '@/components/features/wallets/ReplaceHotWalletDialog';
import { Breadcrumbs } from '@/components/shared/Breadcrumbs';
import { DataTablePagination } from '@/components/shared/DataTablePagination';
import { LoadingState } from '@/components/shared/LoadingState';
import { ErrorState } from '@/components/shared/ErrorState';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { useHotWallet, useHotWalletTransactions } from '@/lib/hooks';
import { ROUTES } from '@/config/routes';

export const Route = createFileRoute('/_auth/_admin/admin/wallets/hot-wallet')({
  component: HotWalletComponent,
});

function HotWalletComponent() {
  const { data, isLoading, isError, error } = useHotWallet();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [replaceOpen, setReplaceOpen] = useState(false);

  const { data: txData, isLoading: txLoading } = useHotWalletTransactions({
    page,
    per_page: perPage,
  });

  const breadcrumbs = [
    { label: 'Wallets', href: ROUTES.ADMIN.WALLETS },
    { label: 'Hot Wallet' },
  ];

  if (isLoading) {
    return <LoadingState />;
  }

  if (isError) {
    return <ErrorState title={error.name} message={error.message} />;
  }

  return (
    <div className="space-y-6">
      <Breadcrumbs items={breadcrumbs} />

      <PageHeader
        title="Hot Wallet"
        description=""
        action={
          <Button variant="outline" onClick={() => setReplaceOpen(true)}>
            <RefreshCw className="mr-2 h-4 w-4" />
            Заменить кошелёк
          </Button>
        }
      />

      <HotWalletCard wallet={data!} />

      <WalletTransactionHistory
        transactions={txData?.data ?? []}
        isLoading={txLoading}
        walletAddress={data!.address}
      />

      {txData?.meta && (
        <DataTablePagination
          meta={txData.meta}
          onPageChange={setPage}
          onPerPageChange={(value) => {
            setPerPage(value);
            setPage(1);
          }}
        />
      )}

      <ReplaceHotWalletDialog
        open={replaceOpen}
        onOpenChange={setReplaceOpen}
        currentAddress={data!.address}
      />
    </div>
  );
}
